import React, { useState } from 'react';

function UploadImage() {
  const [imagen, setImagen] = useState(null);

  const handleFileChange = (e) => {
    setImagen(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!imagen) {
      alert('Selecciona una imagen primero');
      return;
    }

    const formData = new FormData();
    formData.append('imagen', imagen);

    try {
      const res = await fetch('https://ricardodiaztuasesorfinanciero.com/api/upload-image', {
        method: 'POST',
        body: formData,
      });

      const data = await res.json();
      alert(data.message);
    } catch (error) {
      console.error(error);
      alert('Error al subir imagen');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <input type="file" accept="image/*" onChange={handleFileChange} />
      <button type="submit">Subir Imagen</button>
    </form>
  );
}

export default UploadImage;
